/**
 * @file organizationStatus
 *
 * @fileoverview Helpers for the organization status checking.
 */

import { Maybe, OrganizationProfile } from '~/jobiqo/types/types';

/**
 * Checks if an organization profile is considered published based
 * on workflow states.
 *
 * @param {OrganizationProfile} organizationProfile
 *    The organization profile.
 *
 * @returns {bool}
 *   Returns true if the profile is published and false otherwise.
 */
export function isOrganizationProfilePublished(
  organizationProfile?: Maybe<OrganizationProfile>,
) {
  return organizationProfile?.workflowState?.value === 'published';
}
